<template>
    <v-dialog-old ref="dialog" id="metros" @hidden="resetData">
        <form>
            <fieldset style="min-width: 1000px">
                <legend>
                    Выберите станции метро
                </legend>
                <div class="list">
                    <template v-for="option in cityMetro">
                        <label>
                            <input v-if="defaultOptions.indexOf(option.value) !== -1"
                                   type="checkbox"
                                   checked
                                   disabled
                                   :value="option.value"
                                   :class="{'level2': option.level === '2'}" />
                            <input v-else
                                   type="checkbox"
                                   v-model="checked"
                                   :value="option.value"
                                   :class="{'level2': option.level === '2'}" />
                            <span>{{ option.text }}</span>
                        </label>
                    </template>
                </div>
            </fieldset>
        </form>

        <template v-slot:footer>
            <button class="green" @click="fireConfirmEvent">Подтвердить</button>
        </template>
    </v-dialog-old>
</template>

<script>
export default {
    props: {
        city: {
          type: String,
          default: null
        },
        metroOptions: {
            type: Array,
            required: true
        },
        defaultOptions: {
            type: Array,
            default: () => [],
        },
        checkedOptions: {
            type: Array,
            required: true
        }
    },

    data: function () {
        return {
            checked: this.checkedOptions
        };
    },

    methods: {
        resetData() {
            this.checked = this.checkedOptions;
        },
        fireConfirmEvent: function () {
            this.$emit('confirm', this.checked);
        },
        removeWrongMetros(metros) {
            this.checked = this.checked.filter(item => {
                return metros.indexOf(item) === -1;
            });
        },
    },

    computed: {
        cityMetro () {
            if (this.city === null){
                return this.metroOptions
            }
            if (this.metroOptions !== undefined && this.metroOptions.length > 0){
                return this.metroOptions.filter(option => option.city === this.city)
            }
            return []
        },
    },

    watch: {
        checkedOptions (newValue, oldValue) {
            this.checked = newValue;
        }
    }
}
</script>

<style>
#metros {
    min-width: 1000px;
    max-width: 1200px;
}
#metros .list {
        column-count: 4;
    }


</style>
